import { render, staticRenderFns } from "./EmrDataCreate.vue?vue&type=template&id=57871b24&scoped=true&"
import script from "./EmrDataCreate.vue?vue&type=script&lang=js&"
export * from "./EmrDataCreate.vue?vue&type=script&lang=js&"
import style0 from "./EmrDataCreate.vue?vue&type=style&index=0&id=57871b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57871b24",
  null
  
)

export default component.exports